// extracted by mini-css-extract-plugin
export default {"page":"homeStyle_page__gO4o5","heroContainer":"homeStyle_heroContainer__Ixfok","hero":"homeStyle_hero__FOAj1","text":"homeStyle_text__QQVlj"};